function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Showmore from 'integration-web-core--socle/js/assets/modules/_showmore.js';
import { hitEventTms } from "integration-web-core--socle/js/assets/commons/_tms.js";
var cartridgeStoreSelector = document.getElementById('cartridge-store');
var COOKIE_STORE_ID_NAME = cartridgeStoreSelector.dataset.cookiestore;
var NEW_COOKIE_STORE_ID_NAME = cartridgeStoreSelector.dataset.newcookiestore;
var cookieDomain = cartridgeStoreSelector.dataset.cookieDomain;
var StoreSpace = /*#__PURE__*/function (_lm$Composant) {
  function StoreSpace(id) {
    var _this;
    _classCallCheck(this, StoreSpace);
    _this = _callSuper(this, StoreSpace, [id]);
    window.addEventListener('contextualize', function (e) {
      _this.storeLocContext(e.detail);
    }, false);
    var showMoreLink = document.querySelector('#showMoreMessage');
    var showMoreButton = document.querySelector('.l-store-layer__container button[aria-controls="showMoreMessage"]');
    var addShowMore = function addShowMore() {
      var optionShowMoreMessage = {
        id: 'showMoreMessage',
        label: {
          more: storespace.i18n.crisis_more_label,
          less: storespace.i18n.crisis_less_label
        },
        initialHeight: '4rem'
      };
      new Showmore(optionShowMoreMessage);
    };
    if (typeof showMoreLink !== 'undefined' && showMoreLink !== null && showMoreButton === null) {
      addShowMore();
    }
    _this.initContextButtonEvents();
    return _this;
  }
  _inherits(StoreSpace, _lm$Composant);
  return _createClass(StoreSpace, [{
    key: "storeLocContext",
    value: function storeLocContext(storeId) {
      var dataStoreName = cartridgeStoreSelector.dataset.storeName;
      var d = new Date();
      d.setTime(d.getTime() + 390 * 24 * 60 * 60 * 1000);
      var expires = "expires=".concat(d.toUTCString());
      var today = new Date();
      var todayFormat = today.getFullYear() + "0".concat(today.getMonth() + 1).slice(-2) + "0".concat(today.getDate()).slice(-2);
      if (cookieDomain) {
        document.cookie = "".concat(COOKIE_STORE_ID_NAME, "=").concat(storeId, ";domain=").concat(cookieDomain, ";path=/;").concat(expires, ";SameSite=Lax");
        document.cookie = "".concat(NEW_COOKIE_STORE_ID_NAME, "=").concat(storeId, ";domain=").concat(cookieDomain, ";path=/;").concat(expires, ";SameSite=Lax");
        document.cookie = "store=store=".concat(storeId, "|dateContext=").concat(todayFormat, ";domain=").concat(cookieDomain, ";path=/;").concat(expires, ";SameSite=Lax");
        // kill customer_context cookie to avoid conflict with store cookies
        document.cookie = "customer_context=;domain=".concat(cookieDomain, ";path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;SameSite=Lax;");
      }
      lm.localStorageLM.set('context_status', 'context-manual', 390);
      this.isStoreIdParam();
      this.contextualizeEvent(storeId, dataStoreName);
      window.location.reload();
    }
  }, {
    key: "isStoreIdParam",
    value: function isStoreIdParam() {
      history.replaceState(null, null, "".concat(location.protocol, "//").concat(location.host).concat(location.pathname).concat(location.search.replace(/[\?&]storeId=[^&]+/, '').replace(/^&/, '?')));
    }
  }, {
    key: "contextualizeEvent",
    value: function contextualizeEvent(storeId) {
      hitEventTms(window, 'gaEvent', JSON.stringify({
        'categorie': 'Favorite store selected',
        'action': 'store page',
        'label': storeId
      }));
    }
  }, {
    key: "initContextButtonEvents",
    value: function initContextButtonEvents() {
      var storeChangeButtonSelector = cartridgeStoreSelector.querySelector(".js-store-change-button");
      var eventStoreContextLayer = new CustomEvent('openStoreContextLayerInSearchMode');
      storeChangeButtonSelector.addEventListener('click', function () {
        window.dispatchEvent(eventStoreContextLayer);
      });
    }
  }]);
}(lm.Composant);
lm.DOMReady(function () {
  new StoreSpace('storespace');
});